/* global document:true */
/* eslint no-use-before-define: ["error", { "functions": false }] */

/**
 * Loads the passed Javascript file
 *
 * @param  {String} url Url of the script file to load
 */
export function loadScript(url) {
  if (!url || scriptLoaded(url)) {
    return;
  }

  const js = document.createElement('script');
  js.onerror = loadScriptError;

  js.src = url;
  document.body.appendChild(js);
}

/**
 * Loads the passed Stylesheet file
 *
 * @param  {String} url Url of the script file to load
 */
export function loadStylesheet(url) {
  if (!url || cssLoaded(url)) {
    return;
  }

  const css = document.createElement('link');
  css.onerror = loadStylesheetError;

  css.href = url;
  css.type = 'text/css';
  css.rel = 'stylesheet';
  document.body.appendChild(css);
}


/**
 * Loads the passed Stylesheet file
 *
 * @return {Boolean}
 */
export function isSecure() {
  return document.location.protocol === 'https:';
}

/**
 * Checks if the passed Javascript file has been loaded
 *
 * @param  {String} url Url of the script file to load
 * @return {Boolean}
 */
function scriptLoaded(url) {
  const script = document.querySelectorAll(`script[src="${url}"]`);
  return script.length > 0;
}

/**
 * Checks if the passed CSS file has been loaded
 *
 * @param  {String} url Url of the css file to load
 * @return {Boolean}
 */
function cssLoaded(url) {
  const link = document.querySelectorAll(`link[href="${url}"]`);
  return link.length > 0;
}

/**
 * Throws an error when called
 *
 * @param  {HTMLNode} error Script element that triggered the error
 */
function loadScriptError(error) {
  throw new URIError(`The script ${error.target.src} is not accessible.`);
}

/**
 * Throws an error when called
 *
 * @param  {HTMLNode} error Link element that triggered the error
 */
function loadStylesheetError(error) {
  throw new URIError(`The stylesheet ${error.target.href} is not accessible.`);
}
